<template>
  <div>
    <template v-if="!items.hasOwnProperty('param')">
      <b-tabs @activate-tab="changeTab">
        <b-tab v-for="(values, key) in items" :key="key" :title="key">
          <app-tab :items="values" :notData="notData" v-on="$listeners" />
        </b-tab>
      </b-tabs>
    </template>
    <template v-else>
      <b-row v-for="(value, key) in items" :key="key" class="mb-2">
        <b-col sm="2" v-if="!(!notData && key === 'isopen')"><strong>{{ fieldName[key] }}</strong></b-col>
        <b-col>
          <template v-if="key === 'param'">
            <conf-node v-if="items[key].hasOwnProperty('__Value__')" :useDefault="true" :items="items[key]" :userPerm="userPerm()" :strict="true" :notData="notData" />
          </template>
          <b-table v-else-if="key === 'timer'" :items="[items[key]]" :fields="timerFields" />
          <template v-else-if="key === 'isopen'">
            <span v-if="notData">{{ value ? '是' : '否' }}</span>
          </template>
          <template v-else-if="key === 'sign_check'">
            <span v-if="notData">{{ value ? '是' : '否' }}</span>
          </template>
          <span v-else-if="key === 'return_type'">{{ returnTypes[value] }}</span>
          <template v-else-if="key === 'table_conf'">
            <b-row v-for="(i, index) in value" :key="index">
              <b-col sm="2">{{ i.field }}</b-col>
              <b-col sm="2">{{ i.name }}</b-col>
            </b-row>
          </template>
          <template v-else-if="key === 'tag_desc'">
            <b-row v-for="(i, index) in value" :key="index">
              <b-col sm="2">{{ i.tag }}</b-col>
              <b-col sm="2">{{ i.name }}</b-col>
            </b-row>
          </template>
          <span v-else>{{ value }}</span>
        </b-col>
      </b-row>
      <b-row v-if="!notData && items.isopen" class="mt-2">
        <b-col>
          <b-button @click="toExec(items)" :variant="items.return_type === 'FILE' ? 'outline-success' : 'outline-primary'">
            <i class="fa fa-check" /> {{ items.return_type === 'FILE' ? '下载' : '执行' }}
          </b-button>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import utils from '@/utils/utils'

export default {
  name: 'app-tab',
  props: ['items', 'notData'],
  components: {
    'app-tab': () => import('./AppTab.vue'),
    'conf-node': () => import('@/components/Confnode.vue')
  },
  data () {
    return {
      returnTypes: {
        JSON: '数据-JSON',
        TABLE: '数据-表格',
        FILE: '文件'
      },
      fieldName: {
        address: '地址',
        desc: '描述',
        isopen: '开放使用',
        param: '参数',
        timer: '定时配置',
        return_type: '返回值类型',
        data_tag: 'Tag',
        table_conf: '表头配置',
        tag_desc: '标签',
        sign_check: '开启签名校验'
      },
      timerFields: ['second', 'minute', 'hour', 'day', 'month', 'year', 'week', 'day_of_week', 'start_date', 'end_date', 'timezone']
    }
  },
  methods: {
    userPerm () {
      if (!this.$store.getters.loginInfo.authority) {
        return null
      } else if (this.$store.getters.loginInfo.admin_type !== 'normal') {
        return '11111111111111111111111111111111'
      }
      let servicePerm = utils.findInArray(
        this.$store.getters.loginInfo.authority, this.data.service_code, 'authority', 'service_code'
      )
      if (servicePerm) {
        return utils.findInArray(
          servicePerm, this.data.product_code, 'mask', 'product_code'
        )
      } else {
        return null
      }
    },
    toExec (data) {
      if (this.judgeParams(data.param.__Value__)) {
        this.$emit('execute', {
          address: data.address,
          desc: data.desc,
          param: this.getParams(data.param.__Value__),
          return_type: data.return_type,
          data_tag: data.data_tag,
          table_conf: data.table_conf,
          sign_check: data.sign_check
        })
      }
    },
    changeTab (cur, prev, evt) {
      this.$emit('tab-change')
    },
    judgeParams (paramData) {
      let flag = true
      for (let key in paramData) {
        if (paramData[key].__Value__.hasOwnProperty('__value__')) {
          if (paramData[key].__Value__.__required__ && !paramData[key].__Value__.__value__) {
            flag = false
            this.$message.warning(key + '不能为空')
            break
          }
        } else {
          flag = this.judgeParams(paramData[key].__Value__)
        }
      }
      return flag
    },
    getParams (paramData) {
      let tmp = {}
      for (let key in paramData) {
        if (paramData[key].__Value__.hasOwnProperty('__value__')) {
          tmp[key] = paramData[key].__Value__.__value__ || paramData[key].__Value__.__default__
        } else {
          tmp[key] = this.getParams(paramData[key].__Value__)
        }
      }
      return tmp
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AppTab.vue?75f2c3e9